import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.js';
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import Functionality from './context/Functionality.js'
import Text from './context/Text.js'

const router = createBrowserRouter([{ path: '*', element: <Text><Functionality><App /></Functionality></Text> }]);
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><RouterProvider router={router} /></React.StrictMode>);
